<button class="btn btn-success btn-block" [disabled]="!isEnabled || isBlocked || isLocked" (click)="acceptTicket()" title="{{ tooltipTitle }}" #button>
    <i class="fas fa-check" #icon></i>
    <span class="element-text">{{ 'console.accept' | translate }}</span>
</button>